import axios from 'axios'
import firebase from 'firebase/app'
import 'firebase/auth'

// Dev only: sign in as DEV_LOGIN_USER_ID (see /api/devLogin) unless already signed in as that user
const devAutoLogin = async () => {
  if (process.env.NODE_ENV !== 'development') return

  let data
  try {
    const res = await axios.get('/api/devLogin')
    data = res.data
  } catch (e) {
    return // DEV_LOGIN_USER_ID not set
  }

  const auth = firebase.auth()
  // Wait for the persisted session to be restored
  const currentUser = await new Promise((resolve) => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      unsubscribe()
      resolve(user)
    })
  })
  if (currentUser?.uid === data.userId) return

  const { user } = await auth.signInWithCustomToken(data.token)
  // Set next-firebase-auth cookies before reloading so SSR sees the new user
  const idToken = await user.getIdToken()
  await axios.post('/api/login', null, {
    headers: { Authorization: idToken }
  })
  window.location.href = '/displays'
}

export default devAutoLogin
